import { graphql } from '../../gql';

export const recentBookingsQuery = graphql(/*GraphQL*/ `
  query RecentBookingsQuery {
    viewer {
      bookings {
        recent {
          ...BasicBooking
        }
      }
    }
  }
`);
